import { Typography } from '@mui/material';
import { FC } from 'react';
import z from 'zod';

import { entityId } from 'domain/types/ID';
import { useTranslationPrefix } from 'infrastructure/translations/i18n';
import { FormCustomerAutocomplete } from 'targets/web/modules/dashboard/components';

import { Container } from './common';
import { ProfitCenterAutocomplete } from './ProfitCenterAutocomplete';
import { AirportAutocomplete } from './AirportAutocomplete';
import { FacilityAutocomplete } from './FacilityAutocomplete';

export const PrimaryJobDetailsSchema = z.object({
  station: z.object({
    // effectively profit center for now
    id: entityId(),
    code: z.string(),
    name: z.string(),
    state: z.string(),
  }),
  airport: z.object({
    id: entityId(),
    code: z.string(),
    name: z.string(),
  }),
  facility: z.object({
    id: entityId(),
    name: z.string(),
  }),
  customer: z.object({
    id: entityId(),
    code: z.string().optional(),
    name: z.string().optional(),
  }),
});

export type PrimaryJobDetailsData = z.infer<typeof PrimaryJobDetailsSchema>;

export interface PrimaryJobDetailsProps {
  disabled?: boolean;
  stationEditable?: boolean;
  customerEditable?: boolean;
  facilityEditable?: boolean;
}

export const PrimaryJobDetails: FC<PrimaryJobDetailsProps> = ({
  disabled,
  stationEditable,
  customerEditable,
  facilityEditable,
}) => {
  const t = useTranslationPrefix('jobs.details_form.primary_details');

  return (
    <Container gap={4} sx={{ padding: 4 }}>
      <Typography variant="h6">{t('title')}</Typography>

      <ProfitCenterAutocomplete disabled={disabled} stationEditable={stationEditable} />
      <AirportAutocomplete disabled={disabled} stationEditable={stationEditable} />
      <FacilityAutocomplete disabled={disabled || !facilityEditable} />
      <FormCustomerAutocomplete disabled={disabled} customerEditable={customerEditable} />
    </Container>
  );
};
